import React from 'react'
import {Box,Card,CardHeader, CardFooter, CardBody,Text,DataTable} from 'grommet';
import { Package  } from 'grommet-icons';
import ShipmentQuoteBreakdown from './quoteBreakdown';
import ShipmentQuoteTotal from './quoteTotal';
import {shipmentDetailColumns} from './utils/shared/shared'

function ShipmentTrackingDetails(props){
      const shipmentSummaryData = props.shipment.pieces.Packages
      return (
          <Card margin='small' pad='medium' background='background-front' round gap="small" style={{minWidth:720}} hoverIndicator>
               <CardHeader justify='between'>
                  <Box direction='row'><Package color='brand'/><Text margin={{left: 'small'}} weight={'bold'} size="medium">Package Details</Text></Box>
              </CardHeader>
              <CardBody>
              <Box direction='row' justify='between'>
              {/* <Box direction='row' justify='between'><Box direction='row' margin='xsmall'><Tag  background='brand' size='small' name="AWB Number" value={props.shipment.awb_number} /></Box><ReturnLatestTrackingStatus shipment={props.shipment} /></Box> */}
              {/* <ReturnShipmentTracking shipment={props.shipment} load={load} setShowTrackingOverlay={setShowTrackingOverlay} showTrackingOverlay={showTrackingOverlay}  /> */}
              <Box direction='row'>
              {/* <StatusChip shipment={props.shipment} label={'Status'} /> */}
              </Box>
              </Box>
              <Box><DataTable margin='small' background={{header: { color: '#18445C'}}} border={{"body":"bottom"}} columns={shipmentDetailColumns} data={shipmentSummaryData}/></Box>
              {(props.user === 'SuperAdmin' ? <ShipmentQuoteBreakdown shipment={props.shipment} /> : null)}
              {((props.shipment.quote != null && props.displayQuote) || props.user === 'SuperAdmin' ? <ShipmentQuoteTotal shipment={props.shipment} /> : null)}
              </CardBody>         
              <CardFooter>
              {/* <InvoiceChip shipment={props.shipment} /> */}
              </CardFooter>
          </Card>
      )
  }

  export default ShipmentTrackingDetails